export default "__VITE_ASSET__CB7iBB5T__"